const studentInterviewDuration = 35
const mentorInterviewDuration = 40

export {
  studentInterviewDuration,
  mentorInterviewDuration
}